/** Shown on the Candidates / Interviews pages when they were opened from a funnel card: says which
 *  stage the list is narrowed to and clears it (dropping `?stage=` keeps the requirement filter). */
import type { ReactNode } from "react";
import { useSearchParams } from "react-router-dom";
import { X } from "lucide-react";

export function FunnelStageChip({ label, count }: { label: string; count: number }): ReactNode {
  const [params, setParams] = useSearchParams();
  const clear = (): void => {
    const next = new URLSearchParams(params);
    next.delete("stage");
    setParams(next, { replace: true });
  };
  return (
    <div className="funnel-stage-chip" role="status">
      <span>
        Funnel stage: <b>{label}</b> — {count} {count === 1 ? "person has" : "people have"} reached this stage
      </span>
      <button type="button" onClick={clear} aria-label={`Show everyone, not just ${label}`} title="Show everyone">
        <X size={13} aria-hidden="true" /> Show all
      </button>
    </div>
  );
}
